import { render, staticRenderFns } from "./PackageByWeight.vue?vue&type=template&id=609cd54c"
import script from "./PackageByWeight.vue?vue&type=script&lang=js"
export * from "./PackageByWeight.vue?vue&type=script&lang=js"
import style0 from "./PackageByWeight.vue?vue&type=style&index=0&id=609cd54c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports